import tinytime from 'tinytime'

export function parseTime(time, format) {
  if (!time) {
    return ''
  }

  return tinytime(format).render(time)
}

const yyyyMmDdTemplate = tinytime('{YYYY}-{Mo}-{DD}', { padMonth: true })
export function parseTimeYyyyMmDd(time) {
  if (!time) {
    return ''
  }

  return yyyyMmDdTemplate.render(time)
}

const yyyyMoDdHhMmTemplate = tinytime('{YYYY}-{Mo}-{DD} {H}:{mm}', { padMonth: true })
export function parseTimeYyyyMoDdHhMm(time) {
  if (!time) {
    return ''
  }

  return yyyyMoDdHhMmTemplate.render(time)
}

export const moneyformat = (s, n = 2) => { // s是要转换的金额，n为小数位数
  if (!s) { return '0' }
  n = n > 0 && n <= 20 ? n : 2
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
  var l = s.split('.')[0].split('').reverse()
  var r = s.split('.')[1]
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
  }
  let result = t.split('').reverse().join('') + '.' + r
  if (n === 2) {
    if (result.split('.')[1] === '00') {
      result = result.split('.')[0]
    }
  }
  return result
}

function FormatDate(fmt, date) {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function transformDate(value, format = 'yyyy-MM-dd hh:mm') {
  if (!value) {
    return '--'
  }
  return FormatDate(format, new Date(value))
}

export function getNameByValue(key, arr, value = 'value', label = 'label') {
  const obj = arr.find(item => {
    return item[value] === key
  })
  if (obj) {
    return obj[label] || ''
  }
  return key
}
